module.exports = __webpack_public_path__ + "img/login.337bb6b5.jpg";